import React from "react";
import { BrowserRouter, Navigate, Route, Routes as Switch, useLocation } from "react-router-dom";

import { PrivateRoute } from "../components/Routing";

import Layout from "../components/Layout";
import Auth from '../pages/Auth'
import Main from "../pages/Main";
import Roles from "../pages/Roles";
import RoleSettings from "../pages/RoleSettings";
import Candidates from "../pages/Candidates";
import Schedule from '../pages/Schedule'
import Personnel from "../pages/Personnel";
import Students from "../pages/Students";
import Classing from "../pages/Classing";
import Courses from "../pages/Courses";
import SchoolYears from "../pages/SchoolYears";
import SchoolWeeks from "../pages/Weeks";
import Terms from "../pages/Terms";
import Periods from "../pages/Periods";
import ScheduleVariants from "../pages/ScheduleVariants";
import Reports from "../pages/Reports";
import Classbook from "../pages/Classbook";
import ClassbookDO from "../pages/ClassbookDO";
import ClassbookVD from "../pages/ClassbookVD";
import MethodOffice from "../pages/MethodOffice";
import ThematicPlanning from "../pages/ThematicPlanning";
import ThematicPlanningDO from "../pages/ThematicPlanningDO";
import ThematicPlanningVD from "../pages/ThematicPlanningVD";
import Settings from "../pages/Settings";
import DisciplineStructure from "../pages/DisciplineStructure";
import RoomTypes from "../pages/RoomTypes";
import Rooms from "../pages/Rooms";
import Ads from "../pages/Ads";
import FAQ from "../pages/FAQ";
import TypesStudySessions from "../pages/TypesStudySessions";
import GradesOptions from "../pages/GradesOptions";
import GradeWeight from "../pages/GradeWeight";
import EducationalStatuses from "../pages/EducationalStatuses";
import EducationalStructure from "../pages/EducationalStructure";
import Scheduling from "../pages/Scheduling";
import DirectoryObjectsUMB from "../pages/DirectoryObjectsUMB";
import Culture from "../pages/Culture";
import FormsOfEducation from "../pages/FormsOfEducation";
import SubjectsByYearStudy from "../pages/SubjectsByYearStudy";
import Countries from "../pages/Countries";
import ScheduleSettings from "../pages/ScheduleSettings";
import ScheduleSettingsDO from "../pages/ScheduleSettingsDO";
import ScheduleSettingsVD from "../pages/ScheduleSettingsVD";
import StudyPlans from "../pages/StudyPlans";
import TypesOfDisease from "../pages/TypesOfDisease";
import MKBten from "../pages/MKBten";
import Discharge from "../pages/Discharge";
import Healthgroup from "../pages/Healthgroup";
import TypesOfVaccinations from "../pages/TypesOfVaccinations";
import GroupNutrition from "../pages/GroupNutrition";
import PeriodNutrition from "../pages/PeriodNutrition";
import ProfileTrack from "../pages/ProfileTrack";
import Competence from "../pages/Competence";
import EduDirections from "../pages/EduDirections";
import SubjectsExtraEdu from "../pages/SubjectsExtraEdu";
import SubjectsExtraCurEdu from "../pages/SubjectsExtraCurEdu";
import EventLevels from "../pages/EventLevels";
import StudyShifts from "../pages/StudyShifts";
import Achievements from "../pages/Achievements";
import ScheduleVariantsDO from "../pages/ScheduleVariantsDO";
import PersonalScheduleDO from "../pages/PersonalScheduleDO";
import ActivityTypes from "../pages/ActivityTypes";
import EventTypes from "../pages/EventTypes";
import PhysicalGroup from "../pages/PhysicalGroup";
import SpecMedGroup from "../pages/SpecMedGroup";
import AchievementsPoints from "../pages/AchievementsPoints";
import CanteenStaff from "../pages/CanteenStaff";
import ScheduleVariantsVD from "../pages/ScheduleVariantsVD";
import EducDirections from "../pages/EducDirections";
import MedicalCards from "../pages/MedicalCards";
import Manners from "../pages/Manners";
import { Info, Report, Schedule as ExamSchedule } from "../pages/Exam";
import MenuDay from "../pages/MenuDay";
import Dishes from "../pages/Dishes";
import Homeworks from "../pages/Homeworks";
import DigitalExamBook from "../pages/DigitalExamBook";
// import GroupVd from "../pages/GroupVd";
import JournalControl from "../pages/JournalControl";
import JournalControlDO from "../pages/JournalControlDO";
import JournalControlVD from "../pages/JournalControlVD";
import JournalManners from "../pages/JournalManners";
import StudyPlansDO from "../pages/StudyPlansDO";
import StudyPlansVDnew from "../pages/StudyPlansVDnew";
import Subgroups from "../pages/Subgroups";
import EventsList from "../pages/EventsList";
import Holidays from "../pages/Holidays";
import EducationalInstitutions from "../pages/EducationalInstitutions";
import StagesStudy from "../pages/StagesStudy";
import EquipmentGroups from "../pages/EquipmentGroups";
import Equipment from "../pages/Equipment";
import FitnessIndicators from "../pages/FitnessIndicators";
import DailyRoutine from "../pages/DailyRoutine";
import SchedulingDO from "../pages/SchedulingDO";
import SchedulingVD from "../pages/SchedulingVD";
import Admissions from "../pages/Admissions";
import TypicalComment from "../pages/TypicalComment";
import ReportGroups from "../pages/ReportGroups";
import UserDictionary from "../pages/UserDictionary";
import Trajectories from "../pages/Trajectories";
import ExamCity from "../pages/ExamCity";
import ExamBoard from "../pages/ExamBoard";
import TestingSchedule from "../pages/TestingSchedule";
import EnrollQuestions from "../pages/EnrollQuestions";
import Backup from "../pages/Backup";
import Publication from "../pages/Publication";
import SettingLogging from "../pages/SettingLogging";
import UsefulSites from "../pages/UsefulSites";
import ImportingPhotos from "../pages/ImportingPhotos";
import DocumentsJournal from "../pages/DocumentsJournal";
import UnloadingIntegrationSVO from "../pages/UnloadingIntegrationSVO";
import ParentMeetings from "../pages/ParentMeetings";
import StructuralDivisions from "../pages/StructuralDivisions";
import TypesOfDocuments from "../pages/TypesOfDocuments";
import InitialImport from "../pages/InitialImport";
import SecurityLog from "../pages/SecurityLog";
import NewSchoolYear from "../pages/NewSchoolYear";
import Activity from "../pages/Activity";
import Profotbor from "../pages/Profotbor";
import EducationalMethodologicalKits from "../pages/EducationalMethodologicalKits";
import LevelsMethodAssociations from "../pages/LevelsMethodAssociations";
import LoginRegister from "../pages/LoginRegister";
import ApplicantQuestionSet from "../pages/ApplicantQuestionSet";
import MethodologicalAssociation from "../pages/MethodologicalAssociation";
import TimeSlot from "../pages/TimeSlot";
import VideoConfig from "../pages/VideoConfig";
import VideoLessons from "../pages/VideoLessons";
import TvProgramType from "../pages/TvProgramType";
import TvProgramSchedule from "../pages/TvProgramSchedule";
import ApplicantGroup from "../pages/ApplicantGroup";
import Orders from "../pages/Orders";
import Dashboard from "../pages/Dashboard";
import TableDescription from "../pages/TableDescription";
import WebLessons from "../pages/WebLessons";
import GroupsDO from "../pages/GroupsDO";
import GroupsVD from "../pages/GroupsVD";



export default function Routes() {

  return (
    <BrowserRouter>
      <Switch>
        <Route path='/auth' element={<Auth />} />
        <Route element={<PrivateRoute />}>

          <Route path='dashboard' element={<Dashboard.Main />}>
            <Route path='logs' element={<Dashboard.Logs />} />
            <Route path='servers' element={<Dashboard.Servers />} />
          </Route>


          <Route path="/" element={<Layout />}>
            <Route index element={<Main />} />

            <Route path="applicant" element={<Candidates />} />
            <Route path="personnel/:personnelId?" element={<Personnel />} />
            {/* <Route path="variable_stuff" element={<VariableStuff/>} /> */}

            {/* ИНФОРМАЦИОННЫЕ СЕРВИСЫ */}
            <Route path="room_types" element={<RoomTypes />} />
            <Route path="equipment_groups" element={<EquipmentGroups />} />
            <Route path="equipment" element={<Equipment />} />
            <Route path="rooms" element={<Rooms />} />
            <Route path="directoryObjectsUMB" element={<DirectoryObjectsUMB />} />
            <Route path="event_levels" element={<EventLevels />} />
            <Route path="achievements" element={<Achievements />} />
            <Route path="act_types" element={<ActivityTypes />} />
            <Route path="event_types" element={<EventTypes />} />
            <Route path="events_list" element={<EventsList />} />
            <Route path="achiev_points" element={<AchievementsPoints />} />
            <Route path="educ_directions" element={<EducDirections />} />
            <Route path="publication" element={<Publication />} />
            <Route path="useful_sites" element={<UsefulSites />} />
            <Route path="parent_meetings" element={<ParentMeetings />} />
            <Route path="activity" element={<Activity />} />
            <Route path="profotbor">
              <Route index element={<Profotbor.List />} />
              <Route path=":id" element={<Profotbor.Current />} />
            </Route>
            <Route path="tv_program_type" element={<TvProgramType />} />
            <Route path="tv_program_schedule" element={<TvProgramSchedule />} />
            <Route path="web_lessons">
              <Route index element={<WebLessons.List />} />
              <Route path=":id" element={<WebLessons.Current />} />
            </Route>
            {/* ИНФОРМАЦИОННЫЕ СЕРВИСЫ */}



            {/* МЕДПУНКТ */}
            <Route path="medical_cards" element={<MedicalCards />} />
            <Route path="types_of_disease" element={<TypesOfDisease />} />
            <Route path="MKB_ten" element={<MKBten />} />
            <Route path="discharge" element={<Discharge />} />
            <Route path="health_group" element={<Healthgroup />} />
            <Route path="types_of_vaccinations" element={<TypesOfVaccinations />} />
            <Route path="physical_group" element={<PhysicalGroup />} />
            <Route path="special_medical_groups" element={<SpecMedGroup />} />

            {/* СТОЛОВАЯ */}
            <Route path="group_nutrition" element={<GroupNutrition />} />
            <Route path="period_nutrition" element={<PeriodNutrition />} />
            <Route path="canteen_staff" element={<CanteenStaff />} />
            <Route path="menu_day" element={<MenuDay />} />
            <Route path="dishes" element={<Dishes />} />

            {/* ОБРАЗОВАНИЕ / ОСНОВНОЕ ОБРАЗОВАНИЕ */}
            <Route path="study_plans" element={<StudyPlans />} />
            <Route path="edu_directions" element={<EduDirections />} />
            <Route path="students/:studentId?" element={<Students />} />
            <Route path="classing" element={<Classing />} />
            <Route path="courses" element={<Courses />} />
            <Route path="ads" element={<Ads />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="competence" element={<Competence />} />
            <Route path="schedule_variants" element={<ScheduleVariants />} />
            <Route path="discipline_structure_ba" element={<DisciplineStructure from='0' />} />
            <Route path="discipline_structure_do" element={<DisciplineStructure from='1' />} />
            <Route path="discipline_structure_vd" element={<DisciplineStructure from='2' />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="new_school_year" element={<NewSchoolYear />} />
            <Route path="classbook" element={<Classbook />} />
            <Route path="methodOffice" element={<MethodOffice />} />
            <Route path="thematic_planning" element={<ThematicPlanning />} />
            <Route path="culture" element={<Culture />} />
            <Route path="subjects_by_year_study" element={<SubjectsByYearStudy />} />
            <Route path="schedule_settings" element={<ScheduleSettings />} />
            <Route path="track_profile" element={<ProfileTrack />} />
            <Route path="study_shifts" element={<StudyShifts />} />
            <Route path="digital_exam_book" element={<DigitalExamBook />} />
            <Route path="journal_control" element={<JournalControl />} />
            <Route path="manners" element={<Manners />} />
            <Route path="journal_manners" element={<JournalManners />} />
            <Route path="homeworks" element={<Homeworks />} />
            <Route path="subgroups" element={<Subgroups />} />
            {/* МЕТОДИЧЕСКАЯ РАБОТА */}
            <Route path="educational_methodological_kits" element={<EducationalMethodologicalKits />} />
            <Route path="levels_methodological_associations" element={<LevelsMethodAssociations />} />
            {/* <Route path="method_assoc_levels" element={<MethodAssocLevels />} /> */}
            <Route path="methodological_association" element={<MethodologicalAssociation />} />

            <Route path="ege">
              <Route path="info" element={<Info />} />
              <Route path="report" element={<Report />} />
              <Route path="schedule" element={<ExamSchedule />} />
            </Route>
            <Route path="oge">
              <Route path="info" element={<Info ogeMode={true} />} />
              <Route path="report" element={<Report ogeMode={true} />} />
              <Route path="schedule" element={<ExamSchedule ogeMode={true} />} />
            </Route>

            {/* ДОПОЛНИТЕЛЬНОЕ ОБРАЗОВАНИЕ */}
            <Route path="subjects_extra_edu" element={<SubjectsExtraEdu />} />
            <Route path="subjects_extracur_edu" element={<SubjectsExtraCurEdu />} />
            <Route path="do_schedule_variants" element={<ScheduleVariantsDO />} />
            <Route path="study_plans_do" element={<StudyPlansDO />} />
            <Route path="classbook_do" element={<ClassbookDO />} />
            <Route path="journal_control_do" element={<JournalControlDO />} />
            <Route path="scheduling_do" element={<SchedulingDO />} />
            <Route path="personal_schedule_do" element={<PersonalScheduleDO />} />
            <Route path="schedule_settings_do" element={<ScheduleSettingsDO />} />
            <Route path="groups_do" element={<GroupsDO />} />
            <Route path="thematic_planning_do" element={<ThematicPlanningDO />} />

            {/* <Route path="curriculum_do" element={<CurriculumDO />} /> */}
            {/* ДОПОЛНИТЕЛЬНОЕ ОБРАЗОВАНИЕ */}


            {/* ВНЕУРОЧНАЯ ДЕЯТЕЛЬНОСТЬ */}
            {/* <Route path="group_vd" element={<GroupVd />} /> */}
            <Route path="vd_schedule_variants" element={<ScheduleVariantsVD />} />
            <Route path="scheduling_vd" element={<SchedulingVD />} />
            <Route path="vd_schedule_variants" element={<ScheduleVariantsVD />} />
            <Route path="study_plans_vd" element={<StudyPlansVDnew />} />
            <Route path="classbook_vd" element={<ClassbookVD />} />
            <Route path="journal_control_vd" element={<JournalControlVD />} />
            <Route path="schedule_settings_vd" element={<ScheduleSettingsVD />} />
            <Route path="groups_vd" element={<GroupsVD />} />
            <Route path="thematic_planning_vd" element={<ThematicPlanningVD />} />
            {/* ВНЕУРОЧНАЯ ДЕЯТЕЛЬНОСТЬ */}

            {/* ПРИЕМНАЯ КОМИССИЯ */}
            <Route path="admissions" element={<Admissions />} />
            <Route path="trajectories" element={<Trajectories />} />
            <Route path="exam_city" element={<ExamCity />} />
            <Route path="exam_board" element={<ExamBoard />} />
            <Route path="testing_schedule" element={<TestingSchedule />} />
            <Route path="enroll_questions" element={<EnrollQuestions />} />
            <Route path="applicant_question_set" element={<ApplicantQuestionSet />} />
            <Route path="time_slot" element={<TimeSlot />} />
            <Route path="applicant_group" element={<ApplicantGroup />} />
            {/* ПРИЕМНАЯ КОМИССИЯ */}

            {/* НАСТРОЙКИ */}
            <Route path="settings" element={<Settings />} />
            <Route path="educational_structure" element={<EducationalStructure />} />
            <Route path="educational_statuses" element={<EducationalStatuses />} />
            <Route path="grades_options" element={<GradesOptions />} />
            <Route path="grade_weight" element={<GradeWeight />} />
            <Route path="types_study_sessions" element={<TypesStudySessions />} />
            <Route path="school_years" element={<SchoolYears />} />
            <Route path="terms" element={<Terms />} />
            <Route path="school_weeks" element={<SchoolWeeks />} />
            <Route path="forms_of_education" element={<FormsOfEducation />} />
            <Route path="countries" element={<Countries />} />
            <Route path="periods" element={<Periods />} />
            <Route path="holidays" element={<Holidays />} />
            <Route path="educational_institutions" element={<EducationalInstitutions />} />
            <Route path="stages_study" element={<StagesStudy />} />
            <Route path="fitness_indicators" element={<FitnessIndicators />} />
            <Route path="daily_routine" element={<DailyRoutine />} />
            <Route path="typical_comment" element={<TypicalComment />} />
            <Route path="report_groups" element={<ReportGroups />} />
            <Route path="user_dictionary" element={<UserDictionary />} />
            <Route path="backup" element={<Backup />} />
            <Route path="setting_logging" element={<SettingLogging />} />
            <Route path="login_register" element={<LoginRegister />} />
            <Route path="video_config" element={<VideoConfig />} />
            <Route path="video_records" element={<VideoLessons />} />
            <Route path="table_description" element={<TableDescription />} />
            {/* НАСТРОЙКИ */}

            {/* ДОПОЛНИТЕЛЬНО */}
            <Route path="importing_photos" element={<ImportingPhotos />} />
            <Route path="documents_journal" element={<DocumentsJournal />} />
            <Route path="unloading_integration_SVO" element={<UnloadingIntegrationSVO />} />
            <Route path="structural_divisions" element={<StructuralDivisions />} />
            <Route path="initial_import" element={<InitialImport />} />
            <Route path="types_documents" element={<TypesOfDocuments />} />
            <Route path="security_log" element={<SecurityLog />} />
            <Route path="orders" element={<Orders />} />

            {/* ДОПОЛНИТЕЛЬНО */}

            <Route path="roles">
              <Route index element={<Roles />} />
              <Route path=':roleId' element={<RoleSettings />} />
            </Route>

            <Route path="setting_access_rights">
              <Route index element={<Roles />} />
              <Route path=':roleId' element={<RoleSettings />} />
            </Route>

            <Route path="scheduling" element={<Scheduling />} />
            <Route path="reports">
              <Route index element={<Reports />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to='/' replace />} />
      </Switch>
    </BrowserRouter>
  );
}